import { render } from "./HotPlaceQnA.vue?vue&type=template&id=5b1d8ce6"
import script from "./HotPlaceQnA.vue?vue&type=script&lang=js"
export * from "./HotPlaceQnA.vue?vue&type=script&lang=js"

import "./HotPlaceQnA.vue?vue&type=style&index=0&id=5b1d8ce6&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__